
import React from 'react';
import { Button } from '@/components/ui/button';
import { Award } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface PremiumActionButtonProps {
  isPremium: boolean;
  onTogglePremium: () => void;
  icon?: React.ReactNode;
  className?: string;
}

const PremiumActionButton: React.FC<PremiumActionButtonProps> = ({
  isPremium,
  onTogglePremium,
  icon,
  className
}) => {
  // We only render this button when isPremium is false now,
  // but keeping the check for backwards compatibility
  return (
    <Button
      variant="premium"
      size="sm"
      className={cn(
        "flex items-center gap-1",
        className
      )}
      onClick={onTogglePremium}
    >
      {icon || <Award size={16} />}
      <span>Bëje Premium</span>
    </Button>
  );
};

export default PremiumActionButton;
